import React from 'react';
import Skills from '../skills';

const SkillsPage = () => <Skills />;

export default SkillsPage;
